module.exports = __webpack_public_path__ + "img/home_eleven.54288d09.png";